import { select, put, takeLatest } from 'redux-saga/effects';
import { selectMedicationSearch } from '../selectors';
import {
  consts as medicationsConsts,
  actions as medicationsActions,
} from '../requests/medications-req';

function* loadMoreWorker(action) {
  const { payload } = action;
  const { userId, query, offset } = payload;

  const limit = 10;
  const medicationsList = yield select(selectMedicationSearch);

  if (offset >= medicationsList.count) {
    return;
  }

  yield put(
    medicationsActions.send({
      limit,
      query,
      userId,
      offset: offset + limit,
    }),
  );
}

export default function* loadMoreMedicationsSaga() {
  yield takeLatest([medicationsConsts.LOAD_MORE], loadMoreWorker);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/more-medications-saga.js